var _defs, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapSmallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 0.501,
    strokeLinejoin: "bevel",
    strokeMiterlimit: 10,
    fontFamily: "Times New Roman",
    fontSize: 16,
    style: {
      fontVariantLigatures: "none"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    width: "18.352pt",
    height: "18.028pt",
    viewBox: "903.08 -759.381 18.352 18.028",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1",
    transform: "scale(1 -1)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Imported Layer 1",
    transform: "scale(1 -1)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "scale(1 -1)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1 2",
    transform: "scale(1 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    strokeLinejoin: "round",
    stroke: "#323232",
    strokeWidth: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 903.53,750.206 L 903.53,741.803 L 908.766,743.604 L 915.309,741.916 L 920.982,744.042 L 920.982,755.119 L 915.309,753.26 L 912.693,754.133",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 915.309,741.916 L 915.309,753.26",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 908.766,743.661 L 908.766,746.278",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 907.457,748.025 C 906.47,751.31 903.53,751.991 903.53,755.004 C 903.53,757.117 905.408,758.931 907.457,758.931 C 909.504,758.931 911.384,757.117 911.384,755.004 C 911.384,751.991 908.443,751.31 907.457,748.025",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 907.451,756.314 C 906.724,756.314 906.136,755.73 906.136,755.011 C 906.136,754.29 906.724,753.707 907.451,753.707 C 908.176,753.707 908.766,754.29 908.766,755.011 C 908.766,755.73 908.176,756.314 907.451,756.314 Z",
    markerStart: "none",
    markerEnd: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapSmallIcon);
export default __webpack_public_path__ + "static/media/map-small-icon.d1708481b7d6607a53b1f458eb3c635b.svg";
export { ForwardRef as ReactComponent };